import { useEffect, useState } from "react";
import axios from "axios"
import { Card, Modal } from "antd";
import { DownOutlined, DownloadOutlined, UpOutlined } from "@ant-design/icons";
import s3Controller from "controllers/s3Controller";


const backend = process.env.REACT_APP_BACKEND;

const ImageTab = ({ data, imageDeleteHandler, orderChangeHandler, imageConfig }) => {
  const [rightBoxImage, setRightBoxImage] = useState([])

  const getImages = (data) => {
    const id = data.id
    const ContentSettingSentenceDALLE_id = data.ContentSettingSentenceDALLE_id
    axios.get(`${backend}/contents/content_sentence/image_ai/images/${id}/${ContentSettingSentenceDALLE_id}`,)
      .then(res => {
        const source = res.data.data.map((el, idx) => {
          el.num = idx
          return el
        })
        setRightBoxImage(source)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const deleteImage = (e, el) => {
    const id = el.id
    const ContentSettingSentenceDALLE_id = el.ContentSettingSentenceDALLE_id
    const num = el.num
    const file = "AIimages/" + el.sentence_image_filename
    axios.delete(`${backend}/contents/content_sentence/image_ai/images/image/${id}/${ContentSettingSentenceDALLE_id}`)
      .then(res => {

        s3Controller.s3DeleteFile(file, (err, data) => {
          if (err) console.log(err)
        })
        const editCount = res.data.data[2][0].count
        const count = res.data.data[3][0].count
        const imageStatus = res.data.data[4].length === 0 ? "N" : "Y"
        const instance = rightBoxImage.slice()
        instance.splice(num, 1)
        setRightBoxImage(instance)

        imageDeleteHandler(data.num, count, editCount, imageStatus)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const orderUp = (el) => {
    if (el.num !== 0) {
      const originData = JSON.parse(JSON.stringify(rightBoxImage))
      const orderData = rightBoxImage.slice()
      orderData.splice(el.num - 1, 0, el)
      orderData.splice(el.num + 1, 1)
      const newData = orderData.map((el, idx) => {
        el.num = idx
        return el
      })

      axios.patch(`${backend}/contents/content_sentence/image_ai/images/order/${el.ContentSettingSentenceDALLE_id}`, { newData })
        .then(res => {
          const statusArray = res.data.data
          let sentenceStatus = "N"
          const instance = newData.slice().map(el => {
            for (let i = 0; i < statusArray.length; i++) {
              if (el.id === statusArray[i].id) {
                if (statusArray[i].count === 1) {
                  el.imageStatus = "N"
                } else {
                  el.imageStatus = "Y"
                  sentenceStatus = "Y"
                }
                break;
              }
            }
            return el
          })
          setRightBoxImage(instance)
          orderChangeHandler(data.num, sentenceStatus)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
  const orderDown = (el) => {
    if (el.num !== rightBoxImage.length - 1) {
      const orderData = rightBoxImage.slice()
      console.log(orderData)
      orderData.splice(el.num, 1)
      orderData.splice(el.num + 1, 0, el)
      const newData = orderData.map((el, idx) => {
        el.num = idx
        return el
      })

      axios.patch(`${backend}/contents/content_sentence/image_ai/images/order/${el.ContentSettingSentenceDALLE_id}`, { newData })
        .then(res => {
          const statusArray = res.data.data
          let sentenceStatus = "N"
          const instance = newData.slice().map(el => {
            for (let i = 0; i < statusArray.length; i++) {
              if (el.id === statusArray[i].id) {
                if (statusArray[i].count === 1) {
                  el.imageStatus = "N"
                } else {
                  el.imageStatus = "Y"
                  sentenceStatus = "Y"
                }
                break;
              }
            }
            return el
          })
          setRightBoxImage(instance)
          orderChangeHandler(data.num, sentenceStatus)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }



  const resizingImage = (el, idx) => {
    const filename = el.sentence_image_filename
    const id = el.id
    const size = imageConfig.image_downsizing_size
    axios.post(`${backend}/contents/content_sentence/image_ai/ai_images`, { filename, id, size })
      .then(res => {
        const newData = rightBoxImage.slice()
        rightBoxImage[idx].sentence_image_size = size
        setRightBoxImage(newData)
      })
      .catch(err => {
        console.log(err)
        Modal.error({
          title:"리사이징 오류",
          content:"오류가 발생하여 리사이징에 실패했습니다.",
          okText: "확인"
        })
      })
  }


  useEffect(() => {
    getImages(data)
  }, [JSON.stringify(data)])
  return (
    <div style={{ margin: "0px 10px" }}>
      {
        rightBoxImage.map((el, idx) => {
          return (
            <Card
              key={el.id}
              style={{ border: el.imageStatus === "Y" ? "2px solid red" : null, marginBottom: "1px" }}
              cover={
                <img style={{ width: "98%", margin: "0 auto" }} src={`https://englemining-admin.s3.ap-northeast-2.amazonaws.com/AIimages/${el.sentence_image_filename}`} />
              }
              actions={[
                <UpOutlined key="up" onClick={() => orderUp(el)} />,
                <DownOutlined key="down" onClick={() => orderDown(el)} />,
                <DownloadOutlined key="download" onClick={() => resizingImage(el, idx)} />
              ]}
              // title={el.sentence_image_filename}
              title={[
                <div key={el.id} style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <span>{el.sentence_image_filename}</span>
                    <span style={{ color: el.sentence_image_size === "1024x1024" || el.sentence_image_size === "1024x1792" || el.sentence_image_size === "1792x1024" ? "red" : null }}>
                      {`(${el.sentence_image_size})`}
                    </span>
                  </div>
                  <a onClick={(e) => { deleteImage(e, el) }}>삭제</a>
                </div>
              ]}
              bodyStyle={{ padding: 0 }}
              headStyle={{ fontSize: 14, minHeight: "auto", padding: "0px 5px" }}
            >
            </Card>
          )
        })
      }
    </div>
  )
}

export default ImageTab